import React from 'react';
import {
  Container, Col, Row,
} from '../../components/grid';
import {
  LinkStyled,
  Heading1,
  Heading2,
  List,
  Paragraph,
} from '../../components/typography';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import PageLink from '../../components/PageLink';
import RowProductView from '../../components/grid/RowProductView';

export default () => (
  <SidemenuLayout menuPicker="Anlaeg" activeSidemenu="Reservedele">
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="0px">
          <Heading1>Reservedele</Heading1>
          <Paragraph>Fadølsanlæg reservedele kan sommetider være en nødvendighed - og heldigvis finder du det her hos Skafte! Her på siden finder du alt hvad du har brug for af fadølsanlæg reservedele, uanset om du er på udkig efter produkter til rensning af anlæg, kulsyretilkobling, øltilkobling, ølaftapning eller køleanlæg. Vores reservedele til fadølsanlæg passer naturligvis til de anlæg vi forhandler, så du kan føle dig sikker i at have dit anlæg i mange år.</Paragraph>
        </Col>
      </Row>
    </Container>
    <Container mb>
      <RowProductView>
        <PageLink
          title="Rensning af fadølsanlæg"
          link="/reservedele/rensning-fadoelsanlaeg"
          image1="reservedele.rensedunk-5-liter-sort.png"
          image1Size={['140px', '100px', '130px', '120px', '100px', '100px']}
          paragraph={
            (
              <React.Fragment>
                <Paragraph>
                  Reservedele til rensning af fadølsanlæg
                </Paragraph>
                <Paragraph>
                  Rensedunke - Rensevæske - Anstikker
                </Paragraph>
              </React.Fragment>
            )
          }
        />
        <PageLink
          title="Kulsyretilkobling"
          link="/reservedele/kulsyre-tilkobling"
          image1="reservedele.trykregulator-uden-studs-stor.png"
          image1Size={['140px', '100px', '130px', '120px', '100px', '100px']}
          paragraph={
            (
              <React.Fragment>
                <Paragraph>
                  Reservedele til kulsyre
                </Paragraph>
                <Paragraph>
                  Trykregulatorer - Manometre - Pakninger -Studser - Slanger - Spændebånd
                </Paragraph>
              </React.Fragment>
            )
          }
        />
        <PageLink
          title="Øltilkobling"
          link="/reservedele/oel-tilkobling"
          image1="reservedele.fadkobling-s-mm.png"
          image1Size={['140px', '100px', '130px', '120px', '100px', '100px']}
          paragraph={
            (
              <React.Fragment>
                <Paragraph>
                  Reservedele til øltilkobling
                </Paragraph>
                <Paragraph>
                  Fadkoblinger - Klemeringe - Pakninger - Ventiler
                </Paragraph>
              </React.Fragment>
            )
          }
        />
        <PageLink
          title="Ølaftapning"
          link="/reservedele/oel-aftapning"
          image1="reservedele.skaller.jpg"
          image1Size={['140px', '100px', '130px', '120px', '100px', '100px']}
          paragraph={
            (
              <React.Fragment>
                <Paragraph>
                  Reservedele til ølaftapning
                </Paragraph>
                <Paragraph>
                  Topringe og plastikskaller- Lynkoblinger - Slanger - Drypbakke
                </Paragraph>
              </React.Fragment>
            )
          }
        />
        <PageLink
          title="Køleanlæg"
          link="/reservedele/koeleanlaeg"
          image1="reservedele.omreremotor-dan-koeler.jpg"
          image1Size={['140px', '100px', '130px', '120px', '100px', '100px']}
          paragraph={
            (
              <React.Fragment>
                <Paragraph>
                  Reservedele til køleanlæg
                </Paragraph>
                <Paragraph>
                  Termostat og omrøremotorer
                </Paragraph>
              </React.Fragment>
            )
          }
        />
      </RowProductView>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>
            Fadølsanlæg reservedele finder du hos Skafte
          </Heading2>
          <Paragraph>
            Hos Skafte har vi specialiseret os i øl og alt hvad det indebærer. Det betyder, at udover at kunne finde både anlæg, ølfustager, barer, haner og meget mere, så finder du naturligvis også fadølsanlæg reservedele der passer til selv samme anlæg.
          </Paragraph>
          <Paragraph>
            Vedligeholdelse af anlægget er vigtigt, da dette sikrer dig den bedste øl-oplevelse, både hvad angår smag og hygiejne. Du finder flere produkter til rens her på siden, men du finder også massevis af fadølsanlæg reservedele - lige fra små skruer, til nye haner og tilkoblinger.
          </Paragraph>
          <Paragraph>
            Foruden korrekt vedligeholdelse, er det også vigtigt at have <LinkStyled to="/kulsyre">kulsyre</LinkStyled> til ølfustagerne. Kulsyren giver den gyldne væske de velkendte og uundværlige bobler, der danser blidt på tungen.
          </Paragraph>
          <Paragraph>
            Er du ikke allerede ejer af et anlæg selv? Husk, at Skafte tilbyder <LinkStyled to="/fadoelsanlaeg">leje af fadølsanlæg</LinkStyled> til din næste fest eller arrangement. Når du vælger at leje et af vores anlæg, bliver det leveret, så det er klappet og klart til brug. Du behøver derfor ikke at tænke over at skulle tilkøbe nogen former for fadølsanlæg reservedele - vi sørger for, at det hele virker som det skal.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>
            Reservedele fadølsanlæg
          </Heading2>
          <Paragraph>
            Her på siden har vi samlet alle vores reservedele til fadølsanlæg. Vi har valgt at inddele dem i flere kategorier, så du let og bekvemt kan finde hvad du søger.
          </Paragraph>
          <Paragraph>
            Find fadølsanlæg reservedele inden for følgende kategorier:
          </Paragraph>
          <List>
            <li>Rensning af fadølsanlæg</li>
            <li>Kulsyretilkobling</li>
            <li>Øltilkobling</li>
            <li>Ølaftapning</li>
            <li>Køleanlæg</li>
          </List>
          <Paragraph>
            Er du i tvivl om hvilken kategori din nye reservedel ligger under? Ved hver kategori kan der ses en lille forsmag på hvad denne indeholder. Du kan eksempelvis finde rensedunke og rensevæske samt anstikkere under kategorien “rensning af fadølsanlæg”.
          </Paragraph>
          <Paragraph>
            Få et hurtigt overblik her:
          </Paragraph>
          <Paragraph underline>
            Rensning af fadølsanlæg
          </Paragraph>
          <Paragraph>
            Det er vigtigt at rense sit anlæg jævnligt, både for at bevare den gode smag i øllen, men også for at opretholde den gode hygiejne. Derfor kan du naturligvis finde et bredt udvalg fadølsanlæg reservedele, der sørger for at rense anlægget godt igennem, så du kan nyde en frisk fra fad eller servere den bedste øl for dine gæster - hver gang.
          </Paragraph>
          <Paragraph>
            I denne kategori finder du:
            <List>
              <li>Rensedunk med S-tilkobling: vælg mellem 5 eller 30 liter</li>
              <li>Rensedunk uden anstikker</li>
              <li>Anstikkere: vælg mellem S-tilkobling, A-tilkobling og G-tilkobling</li>
              <li>Rensevæske: vælg mellem 1 eller 5 liter</li>
            </List>
          </Paragraph>
          <Paragraph>
            Langt størstedelen af fadølsanlæg har en S-tilkobling, hvilket også er grunden til, at du finder en pakkeløsning med både rensedunk og S-tilkobling.
            Anvendes der en anden tilkobling til anlæg, anbefaler vi, at der vælges en rensedunk uden anstikker samt den rette tilkobling ved siden af. Dette sikrer dig, at det hele passer sammen og giver de optimale forhold for rensen.
          </Paragraph>
          <Paragraph underline>
            Kulsyretilkobling
          </Paragraph>
          <Paragraph>
            Der anvendes kulsyre til både øl og danskvand på fad, for at opnå den lækre og brusende fornemmelse. Tilsættes der ikke kulsyre, vil det være en flad oplevelse af nyde den forfriskende drik.
          </Paragraph>
          <Paragraph>
            Blandt vores reservedele til fadølsanlæg og kulsyretilkobling finder du:
          </Paragraph>
          <Paragraph>
            <List>
              <li>Trykregulator til øl</li>
              <li>Trykregulator til danskvand</li>
              <li>Kulsyreslange: almindelig eller forstærket</li>
              <li>Kulsyrenøgle</li>
              <li>Tilkobling til SodaStream og Quooker</li>
              <li>Manometer: vælg mellem 0-6 bar eller 0-200 bar</li>
              <li>Mindre reservedele og elementer: herunder propper, studser, skruer og spændebånd</li>
            </List>
          </Paragraph>
          <Paragraph underline>
            Øltilkobling
          </Paragraph>
          <Paragraph>
            Det er vigtigt, at have den helt rette tilkobling til fustagen, så du kan nyde en skøn øl fra fad. Hos Skafte finder du et bredt udvalg af tilkoblinger, adaptere og andre fadølsanlæg reservedele.
          </Paragraph>
          <Paragraph>
            Vælg mellem følgende tilkoblinger:
          </Paragraph>
          <Paragraph>
            <List>
              <li>A-tilkobling: med studs eller John Guest bøsning</li>
              <li>Cornelius-tilkobling</li>
              <li>D-tilkobling</li>
              <li>G-tilkobling</li>
              <li>K-tilkobling</li>
              <li>M-tilkobling</li>
              <li>S-tilkobling</li>
              <li>S3-tilkobling</li>
              <li>U-tilkobling</li>
            </List>
          </Paragraph>
          <Paragraph>
            Langt størstedelen af vores fustager er med S-tilkobling.
            K-tilkobling anvendes kun til keykegs, hvilket ikke føres hos Skafte, men som kan fås andre steder. Det er derfor vigtigt, at du har mulighed for at finde den rette kobling, så du har mulighed for at nyde øllet.
          </Paragraph>
          <Paragraph underline>
            Ølaftapning
          </Paragraph>
          <Paragraph>
            Disse fadølsanlæg reservedele er uundværlige, hvis du ønsker at tappe øl fra fad. Her finder du alt fra små skruer til plastik skallerne til topring sæt.
          </Paragraph>
          <Paragraph>
            Vælg mellem følgende:
          </Paragraph>
          <Paragraph>
            <List>
              <li>Plastik skaller til topring sæt</li>
              <li>Topring: oval eller rund</li>
              <li>Haner</li>
              <li>Drypbakker</li>
              <li>Ølslange og bremseslange</li>
              <li>Lyntilkobling</li>
              <li>og meget mere..</li>
            </List>
          </Paragraph>
          <Paragraph underline>
            Køleanlæg
          </Paragraph>
          <Paragraph>
            Sørg for kold fadøl til dig selv og dine gæster. Hos Skafte finder du de fadøl reservedele der skal til for at køle og holde øje med temperaturen på øllet og anlægget.
          </Paragraph>
          <Paragraph>
            Vælg fx mellem:
          </Paragraph>
          <Paragraph>
            <List>
              <li>Termostat</li>
              <li>Omrøremotor</li>
            </List>
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white>
      <Row>
        <Col xs={12}>
          <Heading2>
            Fadølsanlæg reservedele til privat og erhverv
          </Heading2>
          <Paragraph>
            Hos Skafte sælger vi fadølsanlæg reservedele til både privat og erhverv, og du har derfor mulighed for at vælge, om du vil se priserne med eller uden moms.
          </Paragraph>
          <Paragraph>
            Vi sælger de rette reservedele til fadølsanlæg, som passer til netop de anlæg som vi også forhandler. Anlæggene egner sig til både erhverv og privat, og kan derfor installeres i hjemmebaren, til privatfesten, på arbejdspladsen eller til firmafesten.
          </Paragraph>
          <Paragraph>
            Hvis du ikke er interesseret i at eje et anlæg og dermed også tænke på fadølsanlæg reservedele, kan du med fordel leje dit anlæg til næste begivenhed hos Skafte. Vi udlejer til privat og erhverv.
          </Paragraph>
          <Paragraph>
            Har du spørgsmål eller er du i tvivl om fadøl reservedele? Tøv ikke med at kontakte os på tlf. 4327 0000 eller mail <LinkStyled anchor to="mailto:peter@skafte.dk">peter@skafte.dk</LinkStyled>.
          </Paragraph>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
